var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUpLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12,7 L21,15 L3,15 L12,7 Z",
  id: "Combined-Shape"
})));
export { SvgArrowUpLarge as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowUpLarge.11e2d011.svg";